import './pagination.less';

const options = {
    elem: 'mu8-pagination', //这里的ID不用加 # 号
    curr: location.href.indexOf('page') !== -1 ? location.href.match(/page=([\d]+)/)[1] : 1,
    prev: '上一页',
    next: '下一页',
    first: '首页',
    last: '尾页',
    count: 0,
    limit: 15, // 每页条数
}

function init(newOptions) {
    if ($(`#${options.elem}`).data('limit')) {
        options.limit = $(`#${options.elem}`).data('limit');
    }
    Object.assign(options, newOptions);
}

function render(newOptions) {
    if (newOptions) {
        init(newOptions);
    }

    layui.use(['laypage'], () => {
        var laypage = layui.laypage;

        //分页
        laypage.render({
            elem: options.elem, //
            curr: options.curr,
            prev: options.prev,
            next: options.next,
            first: options.first,
            last: options.last,
            layout: options.layout, // 分页元素顺序
            count: $(`#${options.elem}`).data('count'), //数据总数，从前端元素中获取，需要在模板文件中生成
            limit: options.limit, // 每页条数
            jump: function (obj, first) {
                //首次不执行
                if (!first) {
                    const currentUrl = location.href;
                    if (currentUrl.indexOf('page=') === -1) {
                        location.href = currentUrl.indexOf('?') !== -1 ? currentUrl + `&page=${obj.curr}` : currentUrl + `?page=${obj.curr}`;
                    } else {
                        location.href = currentUrl.replace(/(page=)[\d]+/, `$1${obj.curr}`);
                    }
                }
            },
        });
    });
}

export default {
    init,
    render,
}